import { useAuth } from '../auth/AuthProvider.js';
import buildErrorHandler from './buildErrorHandler.js';
import wrapAsync from './wrapAsync.js';
/**
 * Create a wrapped network function that has default error callbacks
 *
 * @param f network or async function
 * @param onError error handling callback for network exceptions
 * @internal
 */
const useWrappedNetworkFunction = (f, onError) => {
    const auth = useAuth();
    return wrapAsync(f, { onError: buildErrorHandler(auth._errorCallbacks, onError) });
};
export default useWrappedNetworkFunction;
//# sourceMappingURL=useWrappedNetworkFunction.js.map